/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SwiperItem_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"usePeriodGroupValue_itemSearch">;
    readonly " $refType": "SwiperItem_itemSearch";
};
export type SwiperItem_itemSearch$data = SwiperItem_itemSearch;
export type SwiperItem_itemSearch$key = {
    readonly " $data"?: SwiperItem_itemSearch$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SwiperItem_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwiperItem_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePeriodGroupValue_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'be7c1de0168f880801e8a515ee69d047';
export default node;
